// client/src/hooks/useCrypto.js

import { useState, useCallback } from 'react';
import cryptoService from '../services/cryptoService';

const useCrypto = () => {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState({
    overview: false,
    wallets: false,
    saving: false,
    syncing: false
  });
  const [error, setError] = useState('');

  // Fabrique un appel qui gère le drapeau de chargement et remonte l'erreur.
  const run = useCallback(async (key, fn) => {
    setLoading((prev) => ({ ...prev, [key]: true }));
    setError('');
    try {
      return await fn();
    } catch (err) {
      setError(err.message || 'Une erreur est survenue.');
      throw err;
    } finally {
      setLoading((prev) => ({ ...prev, [key]: false }));
    }
  }, []);

  const fetchOverview = useCallback(
    () =>
      run('overview', async () => {
        const data = await cryptoService.getOverview();
        setOverview(data);
        return data;
      }),
    [run]
  );

  const addWallet = useCallback(
    (data) => run('saving', () => cryptoService.createWallet(data)),
    [run]
  );

  const removeWallet = useCallback(
    (id) => run('saving', () => cryptoService.deleteWallet(id)),
    [run]
  );

  const syncWallet = useCallback((id) => run('syncing', () => cryptoService.syncWallet(id)), [run]);

  // Synchronise chaque wallet l'un après l'autre (les APIs externes sont throttlées).
  const syncAllWallets = useCallback(
    (walletIds) =>
      run('syncing', async () => {
        const summaries = [];
        for (const id of walletIds) {
          // eslint-disable-next-line no-await-in-loop -- synchro séquentielle voulue (throttle APIs externes)
          summaries.push(await cryptoService.syncWallet(id));
        }
        return summaries;
      }),
    [run]
  );

  const editHolding = useCallback(
    (id, data) => run('saving', () => cryptoService.updateHolding(id, data)),
    [run]
  );

  return {
    overview,
    loading,
    error,
    setError,
    fetchOverview,
    addWallet,
    removeWallet,
    syncWallet,
    syncAllWallets,
    editHolding
  };
};

export default useCrypto;
